import * as React from "react";
import { useHistory } from "react-router-dom";
import { RBACButton } from "../../../../molecules/rbac-button";
import { ProcedureEntity } from "../../../../../application/domain/procedures/procedure-entity";
import { PdfOutputConfigurationDescription } from "./description";
import { SmartApplyR } from "../../../../pages/smart-apply/route";

type PdfOutputConfigurationListProps = {
  procedure: ProcedureEntity;
};

export const PdfOutputConfigurationList: React.FC<
  PdfOutputConfigurationListProps
> = ({ procedure }) => {
  const history = useHistory();
  return (
    <div className="columns">
      <PdfOutputConfigurationDescription isArchived={procedure.isArchived()} />
      {!procedure.isArchived() && (
        <div className="column has-text-right is-narrow">
          <div className="is-right has-text-right buttons">
            <RBACButton
              requirePermissions={"procedures.pdf_output_setting_update"}
              onClick={() => {
                history.push(
                  SmartApplyR.ProcedurePDFOutputConfiguration.link({
                    procedureId: procedure.id,
                  }),
                );
              }}
              buttonTypes={"secondary"}
              buttonText={"設定を開始する"}
            />
          </div>
        </div>
      )}
    </div>
  );
};
